import { j as s } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as x } from "react";
const b = (e) => {
  if (e)
    return e;
  const a = (Math.random() + 1).toString(36).substring(7);
  return `${(/* @__PURE__ */ new Date()).valueOf()}-${a}`;
}, h = x(
  ({
    containerClassName: e = "",
    inputClassName: a = "",
    labelClassName: r = "",
    dataTestId: n = "rds-checkbox__label",
    id: o,
    hasError: i,
    style: c,
    children: l,
    ...d
  }, m) => {
    const t = b(o);
    return /* @__PURE__ */ s.jsxs("div", { style: c, className: e, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: m,
          className: a,
          id: t,
          type: "checkbox",
          "aria-invalid": i,
          ...d
        }
      ),
      /* @__PURE__ */ s.jsx("label", { "data-testid": n, htmlFor: t, className: r, children: l })
    ] });
  }
);
h.displayName = "BaseCheckbox";
export {
  h as B,
  b as g
};
